import { ErrorHandler, Injectable, Injector } from '@angular/core'
import { HttpErrorResponse } from '@angular/common/http'
import { LoggingService } from './logging.service'
import { ErrorService } from '@services/error.service'

@Injectable()
export class GlobalErrorHandler implements ErrorHandler {
  constructor(private injector: Injector, private errorService: ErrorService) {}

  // Class to catch all errors and write it to the console log
  handleError(error: Error | HttpErrorResponse) {
    const logger = this.injector.get(LoggingService)

    let message: string

    if (!error) {
      logger.logError('GlobalErrorHandler: undefined error given')
    } else {
      // Server error
      if (error instanceof HttpErrorResponse) {
        message = this.errorService.getServerErrorMessage(error)
      }
      // Client Error
      else {
        message = this.errorService.getClientErrorMessage(error)
      }

      // log the error
      logger.logError(message)
    }
  }
}
